import { LabelListItemContent } from '../LabelListItemContent'
import { ListItem } from '../ListItem'

function LabelListItem(props) {
  return <ListItem {...props} Content={LabelListItemContent} />
}

export default LabelListItem
